import { HoverCard as KobalteHoverCard } from "@kobalte/core/hover-card"
import { Box } from "@/designSystem/components/box"
import { Icon } from "@/designSystem/components/icon"
import { Text } from "@/designSystem/components/text"
import { useI18nContext } from "@/i18n/i18n-solid"
import {
  humanContentBadgeClass,
  humanContentBadgeTextClass,
  humanContentHoverCardContentClass,
  humanContentPillClass,
} from "./human-content-badge.css"

export function HumanContentPill(props: { as?: "li" | "span" }) {
  const { LL } = useI18nContext()

  return (
    <KobalteHoverCard gutter={8} openDelay={300} closeDelay={100}>
      <KobalteHoverCard.Trigger
        class={humanContentPillClass}
        tabIndex={-1}
        as={props.as ?? "li"}
      >
        <Icon name="fingerprint" size="12" color="indigo700" />
      </KobalteHoverCard.Trigger>
      <KobalteHoverCard.Portal>
        <KobalteHoverCard.Content class={humanContentHoverCardContentClass}>
          <Box gap="8">
            <Text
              fontSize="h3"
              fontWeight="700"
              color="sand900"
              fontFamily="serif"
            >
              {LL().discover.humanContentTitle()}
            </Text>
            <Text fontSize="s" color="sand950">
              {LL().discover.humanContentDescription()}
            </Text>
          </Box>
        </KobalteHoverCard.Content>
      </KobalteHoverCard.Portal>
    </KobalteHoverCard>
  )
}

export function HumanContentBadge() {
  const { LL } = useI18nContext()

  return (
    <KobalteHoverCard gutter={8} openDelay={300} closeDelay={100}>
      <KobalteHoverCard.Trigger
        class={humanContentBadgeClass}
        tabIndex={-1}
        as="span"
      >
        <Icon name="fingerprint" size="14" color="indigo700" />
        <span class={humanContentBadgeTextClass}>
          {LL().discover.humanContent()}
        </span>
      </KobalteHoverCard.Trigger>
      <KobalteHoverCard.Portal>
        <KobalteHoverCard.Content class={humanContentHoverCardContentClass}>
          <Box gap="8">
            <Text
              fontSize="h3"
              fontWeight="700"
              color="sand900"
              fontFamily="serif"
            >
              {LL().discover.humanContentTitle()}
            </Text>
            <Text fontSize="s" color="sand950">
              {LL().discover.humanContentDescription()}
            </Text>
          </Box>
        </KobalteHoverCard.Content>
      </KobalteHoverCard.Portal>
    </KobalteHoverCard>
  )
}
